var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCurveLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10237_64995",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2203 24.7062C19.5643 24.4004 19.5953 23.8737 19.2895 23.5297L17.189 21.1666L21 21.1666C22.0638 21.1666 22.8116 21.1673 23.3951 21.2149C23.9689 21.2618 24.3101 21.35 24.5741 21.4845C25.1229 21.7641 25.5691 22.2103 25.8488 22.7591C25.9833 23.0232 26.0715 23.3644 26.1183 23.9381C26.166 24.5217 26.1667 25.2694 26.1667 26.3333V27.8333C26.1667 28.2936 26.5398 28.6667 27 28.6667C27.4602 28.6667 27.8333 28.2936 27.8333 27.8333V26.2971C27.8333 25.2777 27.8333 24.4618 27.7795 23.8024C27.7242 23.1256 27.608 22.5406 27.3338 22.0025C26.8944 21.1401 26.1932 20.4389 25.3308 19.9995C24.7926 19.7253 24.2077 19.6091 23.5309 19.5538C22.8715 19.4999 22.0556 19.4999 21.0361 19.4999L17.1891 19.4999L19.2895 17.137C19.5953 16.793 19.5643 16.2663 19.2203 15.9605C18.8763 15.6547 18.3496 15.6857 18.0438 16.0297L14.7105 19.7796C14.4298 20.0954 14.4298 20.5712 14.7105 20.8869L18.0438 24.637C18.3496 24.981 18.8763 25.0119 19.2203 24.7062Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10237_64995)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 20,
    height: 20,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCurveLeft);
export default __webpack_public_path__ + "static/media/arrow-curve-left.962fc913bfc804a84f8d8bd621ee24ca.svg";
export { ForwardRef as ReactComponent };